import { InMemoryOriginsRepository } from "../../../../../test/repositories/inMemoryOriginsRepository"
import { makeOrigin } from "../../../../../test/factories/makeOrigin"
import { IFetchOriginsProtocol } from "../../protocols/origin/IFetchOriginsProtocol"
import { FetchOriginsUseCase } from "./fetchOrigins"
import { OrderBy } from "../../protocols/origin/enums/Order"
import { OrderType } from "../../protocols/leads/enums/Order"
import { OriginStatus } from "@/domain/entities/Origin"

let sut: IFetchOriginsProtocol
let repository: InMemoryOriginsRepository

describe('Fetch Origins', () => {
  beforeEach(() => {
    repository = new InMemoryOriginsRepository()
    sut = new FetchOriginsUseCase(repository)
  })
  it('Should be able to fetch origins', async () => {

    for (let i = 1; i <= 8; i++) {
      repository.items.push(makeOrigin({
        name: `Test Origin ${i}`
      }))
    }

    const { origins, nextPage, totalPages, perPage } = await sut.execute({limit: 5, orderBy: OrderBy.NAME, orderType: OrderType.ASC, page: 2})

    expect(origins.length).toEqual(3)
    expect(origins[0].name).toEqual('Test Origin 6')
    expect(nextPage).toBeNull()
    expect(totalPages).toEqual(2)
    expect(perPage).toEqual(5)
  })

  it('Should be able to fetch origins filtered by name', async () => {

    for (let i = 1; i <= 8; i++) {
      repository.items.push(makeOrigin({
        name: `Test Origin ${i}`
      }))
    }

    repository.items.push(makeOrigin({
      name: 'Origin Filtered'
    }))

    const { origins, nextPage, totalPages, perPage } = await sut.execute({limit: 5, orderBy: OrderBy.NAME, orderType: OrderType.ASC, page: 1, name: 'Filtered'})

    expect(origins.length).toEqual(1)
    expect(origins[0].name).toEqual('Origin Filtered')
    expect(nextPage).toBeNull()
    expect(totalPages).toEqual(1)
    expect(perPage).toEqual(5)
  })

  it('Should be able to fetch origins filtered by name', async () => {

    for (let i = 1; i <= 8; i++) {
      repository.items.push(makeOrigin({
        name: `Test Origin ${i}`
      }))
    }

    repository.items.push(makeOrigin({
      status: OriginStatus.DISABLED
    }))

    const { origins, nextPage, totalPages, perPage } = await sut.execute({limit: 5, orderBy: OrderBy.NAME, orderType: OrderType.ASC, page: 1, status: OriginStatus.DISABLED})

    expect(origins.length).toEqual(1)
    expect(nextPage).toBeNull()
    expect(totalPages).toEqual(1)
    expect(perPage).toEqual(5)
  })
})